import { ReactNode } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';

import { AppButton } from "@/components/common/atoms/AppButton";

interface AppDialogProps {
    open: boolean;
    title: string;
    children: ReactNode;
    onClose: () => void;

    showActions?: boolean;
    onConfirm?: () => void;
    confirmText?: string;
    hideConfirmButton?: boolean;
    /** Disables the confirm button — e.g. while its mutation is pending, to block duplicate submits. */
    confirmDisabled?: boolean;
}

export const AppDialog = ({
    open,
    title,
    children,
    onClose,
    showActions = false,
    onConfirm,
    confirmText = "Confirm",
    hideConfirmButton = false,
    confirmDisabled = false
}: AppDialogProps) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="md"
            fullWidth
        >
            <DialogTitle
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                }}>
                {title}

                <IconButton onClick={onClose} size="small">
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent sx={{ p: 0 }}>
                {children}
            </DialogContent>

            {showActions && (
                <DialogActions>
                    <AppButton
                        variant="outlined"
                        onClick={onClose}
                    >
                        Cancel
                    </AppButton>

                    {!hideConfirmButton && (
                        <AppButton
                            color="error"
                            onClick={onConfirm}
                            disabled={confirmDisabled}
                        >
                            {confirmText}
                        </AppButton>
                    )}
                </DialogActions>
            )}
        </Dialog>
    );
};